import script from "./TaskCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCreate.vue?vue&type=script&setup=true&lang=js"

import "./TaskCreate.vue?vue&type=style&index=0&id=38cf32c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38cf32c4"]])

export default __exports__